"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var debounce_1 = __importDefault(require("lodash/debounce"));
var set_1 = __importDefault(require("lodash/set"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var query_string_1 = __importDefault(require("query-string"));
var react_1 = __importDefault(require("react"));
var react_intl_1 = require("react-intl");
var Container_1 = __importDefault(require("./components/Container"));
var OverridableComponent_1 = __importDefault(require("./components/OverridableComponent"));
var Stylesheet_1 = __importDefault(require("./components/Stylesheet"));
var constants_1 = __importDefault(require("./core/constants"));
var socket_1 = __importDefault(require("./core/socket"));
var Chat_1 = __importDefault(require("./icons/Chat"));
var utils_1 = require("./utils");
var _values = function (obj) { return Object.keys(obj).map(function (x) { return obj[x]; }); };
var Web = /** @class */ (function (_super) {
    __extends(Web, _super);
    function Web(props) {
        var _this = _super.call(this, props) || this;
        _this.hasBeenInitialized = false;
        _this.cssLoaded = false;
        _this.isCurrentConversation = function (event) {
            var _a;
            return !((_a = _this.props.config) === null || _a === void 0 ? void 0 : _a.conversationId) || _this.props.config.conversationId === event.conversationId;
        };
        _this.handleIframeApi = function (_a) {
            var _b = _a.data, action = _b.action, payload = _b.payload;
            return __awaiter(_this, void 0, void 0, function () {
                var type, text;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!(action === 'configure')) return [3 /*break*/, 1];
                            this.props.updateConfig(Object.assign({}, constants_1.default.DEFAULT_CONFIG, payload));
                            return [3 /*break*/, 19];
                        case 1:
                            if (!(action === 'mergeConfig')) return [3 /*break*/, 2];
                            this.props.mergeConfig(payload);
                            return [3 /*break*/, 19];
                        case 2:
                            if (!(action === 'sendPayload')) return [3 /*break*/, 4];
                            return [4 /*yield*/, this.props.sendData(payload)];
                        case 3:
                            _c.sent();
                            return [3 /*break*/, 19];
                        case 4:
                            if (!(action === 'change-user-id')) return [3 /*break*/, 6];
                            return [4 /*yield*/, this.props.setCustomUserId(payload)];
                        case 5:
                            _c.sent();
                            return [3 /*break*/, 19];
                        case 6:
                            if (!(action === 'new-session')) return [3 /*break*/, 9];
                            // To create a new session, we change the socket user and re-initialize
                            // the connection like if it was the first time using the webchat
                            this.props.resetConversation();
                            this.socket.newUserId();
                            return [4 /*yield*/, this.socket.waitForUserId()];
                        case 7:
                            _c.sent();
                            return [4 /*yield*/, this.props.initializeChat()];
                        case 8:
                            _c.sent();
                            return [3 /*break*/, 19];
                        case 9:
                            if (!(action === 'event')) return [3 /*break*/, 19];
                            type = payload.type, text = payload.text;
                            if (!(type === 'show')) return [3 /*break*/, 10];
                            this.props.showChat();
                            (0, utils_1.trackWebchatState)('show');
                            return [3 /*break*/, 19];
                        case 10:
                            if (!(type === 'hide')) return [3 /*break*/, 11];
                            this.props.hideChat();
                            (0, utils_1.trackWebchatState)('hide');
                            return [3 /*break*/, 19];
                        case 11:
                            if (!(type === 'toggle')) return [3 /*break*/, 12];
                            this.props.displayWidgetView ? this.props.showChat() : this.props.hideChat();
                            (0, utils_1.trackWebchatState)('toggle');
                            return [3 /*break*/, 19];
                        case 12:
                            if (!(type === 'message')) return [3 /*break*/, 14];
                            (0, utils_1.trackMessage)('sent');
                            return [4 /*yield*/, this.props.sendMessage(text)];
                        case 13:
                            _c.sent();
                            return [3 /*break*/, 19];
                        case 14:
                            if (!(type === 'loadConversation')) return [3 /*break*/, 16];
                            return [4 /*yield*/, this.props.store.fetchConversation(payload.conversationId)];
                        case 15:
                            _c.sent();
                            return [3 /*break*/, 19];
                        case 16:
                            if (!(type === 'toggleBotInfo')) return [3 /*break*/, 17];
                            this.props.toggleBotInfo();
                            return [3 /*break*/, 19];
                        case 17: return [4 /*yield*/, this.props.sendData({ type: type, payload: payload })];
                        case 18:
                            _c.sent();
                            _c.label = 19;
                        case 19: return [2 /*return*/];
                    }
                });
            });
        };
        _this.handleClearMessages = function (event) {
            if (_this.isCurrentConversation(event)) {
                _this.props.clearMessages();
            }
        };
        _this.handleNewMessage = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (((_a = event.payload) === null || _a === void 0 ? void 0 : _a.type) === 'visit') {
                            // don't do anything, it's the system message
                            return [2 /*return*/];
                        }
                        if (!this.isCurrentConversation(event)) {
                            // don't do anything, it's a message from another conversation
                            return [2 /*return*/];
                        }
                        (0, utils_1.trackMessage)('received');
                        return [4 /*yield*/, this.props.addEventToConversation(event)
                            // there's no focus on the actual conversation
                        ];
                    case 1:
                        _b.sent();
                        if (!((document.hasFocus && !document.hasFocus()) || this.props.activeView !== 'side')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.playSound()];
                    case 2:
                        _b.sent();
                        this.props.incrementUnread();
                        _b.label = 3;
                    case 3:
                        this.handleResetUnreadCount();
                        if (!(!['session_reset'].includes(event.payload.type) && event.id !== this.lastMessageId)) return [3 /*break*/, 5];
                        this.lastMessageId = event.id;
                        return [4 /*yield*/, this.props.store.loadEventInDebugger(event.id)];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.handleTyping = function (event) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isCurrentConversation(event)) {
                            // don't do anything, it's a message from another conversation
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.props.updateTyping(event)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleDataMessage = function (event) {
            if (!event || !event.payload) {
                return;
            }
            var language = event.payload.language;
            if (!language) {
                return;
            }
            _this.props.updateBotUILanguage(language);
        };
        _this.playSound = (0, debounce_1.default)(function () { return __awaiter(_this, void 0, void 0, function () {
            var disableNotificationSound;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        disableNotificationSound = this.config.disableNotificationSound === undefined
                            ? this.props.config.disableNotificationSound
                            : this.config.disableNotificationSound;
                        if (disableNotificationSound || this.audio.readyState < 2) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.audio.play()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, constants_1.default.MIN_TIME_BETWEEN_SOUNDS);
        _this.handleResetUnreadCount = function () {
            var _a;
            if (((_a = document.hasFocus) === null || _a === void 0 ? void 0 : _a.call(document)) && _this.props.activeView === 'side') {
                _this.props.resetUnread();
            }
        };
        (0, utils_1.checkLocationOrigin)();
        (0, utils_1.initializeAnalytics)();
        return _this;
    }
    Web.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.audio = new Audio("".concat(window.ROOT_PATH, "/assets/modules/channel-web/notification.mp3"));
                        this.props.store.setIntlProvider(this.props.intl);
                        window.store = this.props.store;
                        window.addEventListener('message', this.handleIframeApi);
                        window.addEventListener('keydown', function (e) {
                            if (!_this.props.config.closeOnEscape) {
                                return;
                            }
                            if (e.key === 'Escape') {
                                _this.props.hideChat();
                                if (_this.props.config.isEmulator) {
                                    window.parent.document.getElementById('mainLayout').focus();
                                }
                            }
                        });
                        return [4 /*yield*/, this.load()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.initializeIfChatDisplayed()];
                    case 2:
                        _a.sent();
                        this.props.setLoadingCompleted();
                        return [2 /*return*/];
                }
            });
        });
    };
    Web.prototype.componentWillUnmount = function () {
        window.removeEventListener('message', this.handleIframeApi);
    };
    Web.prototype.componentDidUpdate = function () {
        if (this.config) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.initializeIfChatDisplayed();
        }
    };
    Web.prototype.initializeIfChatDisplayed = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.hasBeenInitialized) {
                            return [2 /*return*/];
                        }
                        if (!(this.props.activeView === 'side' || this.props.isFullscreen)) return [3 /*break*/, 5];
                        this.hasBeenInitialized = true;
                        if (!(this.isLazySocket() || !this.socket)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.initializeSocket()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.socket.waitForUserId()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.props.initializeChat()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Web.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storePath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.config = this.extractConfig();
                        if (this.config.exposeStore) {
                            storePath = this.config.chatId ? "".concat(this.config.chatId, ".webchat_store") : 'webchat_store';
                            (0, set_1.default)(window.parent, storePath, this.props.store);
                        }
                        this.config.overrides && this.loadOverrides(this.config.overrides);
                        this.config.containerWidth && this.postMessageToParent('setWidth', this.config.containerWidth);
                        this.config.reference && this.props.setReference();
                        return [4 /*yield*/, this.props.fetchBotInfo()];
                    case 1:
                        _a.sent();
                        if (!!this.isLazySocket()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.initializeSocket()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        this.setupObserver();
                        return [2 /*return*/];
                }
            });
        });
    };
    Web.prototype.postMessageToParent = function (type, value) {
        var _a;
        (_a = window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({ type: type, value: value, chatId: this.config.chatId }, '*');
    };
    Web.prototype.extractConfig = function () {
        var decodeIfRequired = function (options) {
            try {
                return decodeURIComponent(options);
            }
            catch (_a) {
                return options;
            }
        };
        var _a = query_string_1.default.parse(location.search), options = _a.options, ref = _a.ref;
        var config = JSON.parse(decodeIfRequired(options || '{}')).config;
        var userConfig = Object.assign({}, constants_1.default.DEFAULT_CONFIG, config);
        userConfig.reference = config.ref || ref;
        this.props.updateConfig(userConfig, this.props.bp);
        return userConfig;
    };
    Web.prototype.initializeSocket = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.socket = new socket_1.default(this.props.bp, this.config);
                        this.socket.onClear = this.handleClearMessages;
                        this.socket.onMessage = this.handleNewMessage;
                        this.socket.onTyping = this.handleTyping;
                        this.socket.onData = this.handleDataMessage;
                        this.socket.setup(this.config.userId);
                        return [4 /*yield*/, this.socket.waitForUserId()];
                    case 1:
                        _a.sent();
                        if (!this.config.userId) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.props.setCustomUserId(this.config.userId)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Web.prototype.loadOverrides = function (overrides) {
        var _this = this;
        try {
            for (var _i = 0, _a = _values(overrides); _i < _a.length; _i++) {
                var override = _a[_i];
                override.map(function (_a) {
                    var module = _a.module;
                    return _this.props.bp.loadModuleView(module, true);
                });
            }
        }
        catch (err) {
            console.error('Error while loading overrides', err.message);
        }
    };
    Web.prototype.setupObserver = function () {
        var _this = this;
        (0, mobx_1.observe)(this.props.config, 'userId', function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (data.oldValue === data.newValue) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.props.setCustomUserId(data.newValue)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        (0, mobx_1.observe)(this.props.config, 'overrides', function (data) {
            if (data.newValue && window.parent) {
                _this.loadOverrides(data.newValue);
            }
        });
        (0, mobx_1.observe)(this.props.dimensions, 'container', function (data) {
            if (data.newValue && window.parent) {
                _this.postMessageToParent('setWidth', data.newValue);
            }
        });
    };
    Web.prototype.isLazySocket = function () {
        var _a;
        if (this.config.lazySocket !== undefined) {
            return this.config.lazySocket;
        }
        return (_a = this.props.botInfo) === null || _a === void 0 ? void 0 : _a.lazySocket;
    };
    Web.prototype.renderWidget = function () {
        var _a;
        if (!this.props.showWidgetButton) {
            return null;
        }
        return (react_1.default.createElement("button", { className: (0, classnames_1.default)('bpw-widget-btn', 'bpw-floating-button', (_a = {},
                _a["bpw-anim-".concat(this.props.widgetTransition) || 'none'] = true,
                _a)), "aria-label": this.props.intl.formatMessage({ id: 'widget.toggle' }), onClick: this.props.showChat.bind(this) },
            react_1.default.createElement(Chat_1.default, null),
            this.props.hasUnreadMessages && react_1.default.createElement("span", { className: 'bpw-floating-button-unread' }, this.props.unreadCount)));
    };
    Web.prototype.applyAndRenderStyle = function () {
        var _a;
        var _this = this;
        var emulatorClass = this.props.isEmulator ? ' emulator' : '';
        var parentClass = (0, classnames_1.default)("bp-widget-web bp-widget-".concat(this.props.activeView).concat(emulatorClass), (_a = {
                'bp-widget-hidden': !this.props.showWidgetButton && this.props.displayWidgetView
            },
            _a[this.props.config.className] = !!this.props.config.className,
            _a));
        if (this.parentClass !== parentClass) {
            this.postMessageToParent('setClass', parentClass);
            this.parentClass = parentClass;
        }
        var _b = this.props.config, isEmulator = _b.isEmulator, stylesheet = _b.stylesheet, extraStylesheet = _b.extraStylesheet;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            !!(stylesheet === null || stylesheet === void 0 ? void 0 : stylesheet.length) && react_1.default.createElement(Stylesheet_1.default, { href: stylesheet }),
            !stylesheet && (react_1.default.createElement(Stylesheet_1.default, { href: "assets/modules/channel-web/default".concat(isEmulator ? '-emulator' : '', ".css"), onLoad: function () { return (_this.cssLoaded = true); } })),
            !utils_1.isIE && react_1.default.createElement(Stylesheet_1.default, { href: 'assets/modules/channel-web/font.css' }),
            !!(extraStylesheet === null || extraStylesheet === void 0 ? void 0 : extraStylesheet.length) && react_1.default.createElement(Stylesheet_1.default, { href: extraStylesheet })));
    };
    Web.prototype.render = function () {
        if (!this.props.isWebchatReady) {
            return null;
        }
        return (react_1.default.createElement("div", { onFocus: this.handleResetUnreadCount },
            this.applyAndRenderStyle(),
            this.cssLoaded && (react_1.default.createElement("h1", { id: "tchat-label", className: "sr-only", tabIndex: -1 }, this.props.intl.formatMessage({
                id: 'widget.title',
                defaultMessage: 'Chat window'
            }))),
            react_1.default.createElement(OverridableComponent_1.default, { name: 'before_widget', original: null }),
            this.props.displayWidgetView ? this.renderWidget() : react_1.default.createElement(Container_1.default, null)));
    };
    return Web;
}(react_1.default.Component));
exports.default = (0, mobx_react_1.inject)(function (_a) {
    var store = _a.store;
    return ({
        store: store,
        config: store.config,
        sendData: store.sendData,
        initializeChat: store.initializeChat,
        botInfo: store.botInfo,
        fetchBotInfo: store.fetchBotInfo,
        updateConfig: store.updateConfig,
        mergeConfig: store.mergeConfig,
        addEventToConversation: store.addEventToConversation,
        clearMessages: store.clearMessages,
        updateTyping: store.updateTyping,
        sendMessage: store.sendMessage,
        setReference: store.setReference,
        isEmulator: store.isEmulator,
        updateBotUILanguage: store.updateBotUILanguage,
        isWebchatReady: store.view.isWebchatReady,
        showWidgetButton: store.view.showWidgetButton,
        hasUnreadMessages: store.view.hasUnreadMessages,
        unreadCount: store.view.unreadCount,
        resetUnread: store.view.resetUnread,
        incrementUnread: store.view.incrementUnread,
        activeView: store.view.activeView,
        isFullscreen: store.view.isFullscreen,
        showChat: store.view.showChat,
        hideChat: store.view.hideChat,
        toggleBotInfo: store.view.toggleBotInfo,
        dimensions: store.view.dimensions,
        widgetTransition: store.view.widgetTransition,
        displayWidgetView: store.view.displayWidgetView,
        setLoadingCompleted: store.view.setLoadingCompleted,
        sendFeedback: store.sendFeedback,
        setCustomUserId: store.setCustomUserId,
        resetConversation: store.resetConversation
    });
})((0, react_intl_1.injectIntl)((0, mobx_react_1.observer)(Web)));
